var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 54,
    viewBox: "0 0 92 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.700684,
    y: 0.936035,
    width: 91.2234,
    height: 52.1277,
    rx: 26.0638,
    fill: "white",
    fillOpacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1714 26.1855C32.7216 26.1855 32.3569 26.5502 32.3569 27C32.3569 27.4498 32.7216 27.8145 33.1714 27.8145L33.1714 27L33.1714 26.1855ZM60.0295 27.5759C60.3476 27.2579 60.3476 26.7421 60.0295 26.4241L54.8461 21.2407C54.528 20.9226 54.0123 20.9226 53.6942 21.2407C53.3761 21.5587 53.3761 22.0744 53.6942 22.3925L58.3017 27L53.6942 31.6075C53.3761 31.9256 53.3761 32.4413 53.6942 32.7593C54.0123 33.0774 54.528 33.0774 54.8461 32.7593L60.0295 27.5759ZM33.1714 27L33.1714 27.8145L59.4536 27.8145L59.4536 27L59.4536 26.1855L33.1714 26.1855L33.1714 27Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqButton);
export default __webpack_public_path__ + "static/media/faq-button.460b41101ffcdbdab629cca9ac0260db.svg";
export { ForwardRef as ReactComponent };